export class PriorityLevelViewModel {
  public get creditsLeft(): number {
    if (this.available) {
      return this.creditsBalance - this.creditsPrice;
    } else {
      return 0;
    }
  }

  public get available(): boolean {
    return this.creditsBalance >= this.creditsPrice;
  }
  constructor(
    public id: number,
    public name: string,
    public colorHex: string,
    private creditsBalance,
    private creditsPrice: number,
    public dueDate: string,
  ) {}
}
